import ApplicationSerializer from 'eflex/serializers/application';

export default class BarcodeStringSerializer extends ApplicationSerializer {
  attrs = {
    task: {
      serialize: false,
      deserialize: false,
    },
    taskConfig: {
      serialize: false,
      deserialize: false,
    },
  };
}
